export default "__VITE_PUBLIC_ASSET__8ffe0eb0__"